module.exports = {
      id: "cdf05aaa4852a4fa48f19cadaf4ab852roofShape-half-hip.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#cdf05aaa4852a4fa48f19cadaf4ab852roofShape-half-hip.svg",
      toString: function () {
        return this.url;
      }
    }